import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import translate from '../../locales';

const __t = translate;

class OkDialog extends React.Component {
  constructor(props) {
    super(props);
  };

  handleClose = (action) => () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose(action);
    }
  };

  render() {
    const { title, content, open } = this.props;
    return (
      <div>
        <Dialog
          open={open || false}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose()} color="primary">
              {__t('ok')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

OkDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  onClose: PropTypes.func
}

export default OkDialog;